// Constants and column definitions for PedsReview component
import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export const CENTER_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'CBER', value: 'CBER' },
  { label: 'CDER', value: 'CDER' }
];

export const CENTER_MAPPING: any = {
  CBER: 'CBER',
  CDER: 'CDER'
};

export const getPedsReviewColumns = (onView: (row: any) => void) => [
  {
    field: 'action',
    headerName: 'Action',
    headerAlign: 'center',
    width: 120,
    align: 'center',
    sortable: false,
    filterable: false,
    renderCell: ({ row }: any) => (
      <Button variant='contained' color='primary' onClick={() => onView(row)}>
        <Typography>View</Typography>
      </Button>
    )
  },
  {
    field: 'application_number',
    headerName: 'Application Number',
    headerAlign: 'center',
    width: 150,
    align: 'center'
  },
  {
    field: 'submission_no',
    headerName: 'Submission No',
    headerAlign: 'center',
    width: 130,
    align: 'center'
  },
  {
    field: 'submission_type',
    headerName: 'Submission Type',
    headerAlign: 'center',
    width: 140,
    align: 'center'
  },
  {
    field: 'center',
    headerName: 'Center',
    headerAlign: 'center',
    width: 100,
    align: 'center',
    valueGetter: ({ value }: any) => CENTER_MAPPING[value] || value
  },
  {
    field: 'is_duplicate',
    headerName: 'Duplicate Document',
    headerAlign: 'center',
    width: 100,
    align: 'center',
    valueGetter: ({ value }: any) =>
      value === null || value === undefined ? '' : value ? 'Yes' : 'No'
  },
  {
    field: 'title',
    headerName: 'Title',
    headerAlign: 'center',
    width: 200,
    align: 'center'
  },
  {
    field: 'submission_date',
    headerName: 'Submission Date',
    headerAlign: 'center',
    width: 150,
    align: 'center',
    valueGetter: ({ value }: any) => {
      if (value) {
        const date = new Date(value);
        return date.toLocaleDateString();
      }
      return '';
    }
  },
  {
    field: 'filename',
    headerName: 'Filename',
    headerAlign: 'center',
    width: 180,
    align: 'center'
  },
  {
    field: 'page_count',
    headerName: 'Page Count',
    headerAlign: 'center',
    width: 120,
    align: 'center'
  },
  {
    field: 'created_date',
    headerName: 'Created Date',
    headerAlign: 'center',
    width: 150,
    align: 'center',
    valueGetter: ({ value }: any) => {
      if (value) {
        const date = new Date(value);
        return date.toLocaleDateString();
      }
      return '';
    }
  }
];
